import { render, staticRenderFns } from "./onfleetDriversTaskToday.vue?vue&type=template&id=5fcb3c75"
import script from "./onfleetDriversTaskToday.vue?vue&type=script&lang=js"
export * from "./onfleetDriversTaskToday.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports